import React from "react";
import clsx from "clsx";
import { createUseStyles } from "react-jss";

const useStyles = createUseStyles({
  label: {
    color: "white",
    margin: props =>
      props.margin ?? (props.sidebar ? "0 0 20px 20px" : "15px 15px 0 0"),
    width: props => props.sidebar && "calc(100% - 20px)",
    "font-size": 14,
    display: "flex",
    "align-items": "center",
    cursor: "pointer",
  },
  checkbox: {
    margin: [0, 10, 0, 5],
  },
});

const Checkbox = ({
  onChange,
  value,
  sidebar = false,
  margin,
  className,
  labelClassName,
  children,
  ...props
}) => {
  const classes = useStyles({ sidebar, margin });

  return (
    <label className={clsx(classes.label, labelClassName)}>
      <input
        type="checkbox"
        className={clsx(classes.checkbox, className)}
        checked={value ?? false}
        onChange={evt => onChange(evt.target.checked)}
        {...props}
      />
      {children}
    </label>
  );
};

export default Checkbox;
